var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll('<div class=\'row ' + extraClasses + '\'></div>');
	},
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
		return $owl;
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.popup = {
	init: function () {
		const cookieName = site.popup.getCookieName();
		function openFancybox() {
			$.fancybox({
				'autoDimensions': true,
				closeEffect    : 'fade',
				'scrolling': 'no',
				'autoSize': true,
				'content' : $(".hiddenArea").html(),
				'afterClose': function () {
					Cookies.set(cookieName, 0, {
						expires: 99999
					});
				}
			});
			$('body .hiddenArea').remove();
			$('.fancybox-inner  form').submit(function(e) {
				Cookies.set(cookieName, 1, {
					expires: 99999
				});
			});
		}
		$(document).ready(function () {
			if ($(".hiddenArea").length === 0 || document.body.classList.contains('formbuilder')) {
				return;
			}
			const visited = Cookies.get(cookieName);
			const oldCookie = Cookies.get('lhhestar-konnun');
			if (visited || oldCookie) {
				return false;
			} else {
				openFancybox();
			}
		});
	},

	getCookieName: function() {
		return $('.formbuilder__wrapper', '.hiddenArea').data('codename') ?? $('.box:first-child', '.hiddenArea').attr('id');
	}
};


site.frontpage = {
	init: function () {
		site.frontpage.scroll();

		var $sponsorsCount = $('#sponsors ul .sponsor').first().data('show');
		if (!$sponsorsCount) {
			$sponsorsCount = 8;
		}

		site.owl.init('#sponsors ul', {
			// loop: true,
			nav: true,
			dots: false,
			margin: 10,
			navText: '',
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 4,
				},
				992: {
					items: $sponsorsCount,
				},

			},
		});
	},

	scroll: function () {
		$('span.scroll span', '.box.scroll').on('click', function () {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - offset,
				}, 1000);
				return false;
			}

		});
	},
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	},
});

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	site.popup.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
